<div class="mu-container-mu-map-static">
  <img alt="map static" class="mu-map-static" [src]="urlPath" *ngIf="urlPath" />
</div>
